const strict = true;

const getDefaultState = () => {
  return {
    loadingDialog: false,
    loadingMsg: "",
    counter: 0
  };
};

const state = getDefaultState();

const getters = {
  loadingDialog: state => state.loadingDialog,
  loadingMsg: state => state.loadingMsg
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  setLoadingMsg(state, text) {
    state.loadingMsg = text;
  },
  OPEN_LOADING_DIALOG(state, text) {
    state.loadingDialog = true;
    state.loadingMsg = text;
    state.counter++;
  },
  CLOSE_LOADING_DIALOG(state) {
    state.counter--;
    if (state.counter <= 0) {
      state.counter = 0;
      state.loadingDialog = false;
    }
  }
};

const actions = {};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
